import { useEffect, useState } from 'react'

/** O valor, mas só depois de `espera` ms sem mudar: a pausa entre as teclas. */
export function useAtraso<T>(valor: T, espera: number): T {
  const [atrasado, setAtrasado] = useState(valor)
  useEffect(() => {
    const temporizador = setTimeout(() => setAtrasado(valor), espera)
    return () => clearTimeout(temporizador)
  }, [valor, espera])
  return atrasado
}
